<template>
    <div class="txt-no-data">
        <template v-if="message">{{message}}</template>
        <template v-else>暂无数据</template>
    </div>
</template>

<script>
    export default {
        name: 'txt-no-data',
        props: ['message']
    }
</script>
